import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { AccountTemplate } from '../../../types/AccountTemplate';

export const fetchAccountTemplate = async (uuid: string | undefined) => {
  if (uuid === undefined) return null;

  const response = await CustomAxios.get<AccountTemplate>(`account_templates/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetAccountTemplateByIdProps {
  uuid?: string;
}

export function useGetAccountTemplateById({ uuid }: UseGetAccountTemplateByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allAccountTemplates, uuid],
    queryFn: () => fetchAccountTemplate(uuid),
  });

  return query;
}
